import React, {Fragment} from "react";
import {
    s_char_mods_kv,
    s_char_mods_mv,
    s_char_mods_sv,
} from "../_signals/s_char_mods";


export function displayVerteidigungModNSC(verteidigung) {
    let mod = 0;
    switch (verteidigung) {
        case 'kv':
            mod = s_char_mods_kv.value;
            break;
        case 'mv':

            mod = s_char_mods_mv.value;
            break;
        case 'sv':
            mod = s_char_mods_sv.value;
    }

    if (mod === 0) return <></>;
    if (mod < 0) return <>{mod}</>;
    return <> +{mod}</>;
}